import { AccordionItemStyled } from 'modules/mainmenu/responses/styles'
import { AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { ReactComponent as ExpandedOn } from 'assets/images/icons/expander_on.svg'
import { ReactComponent as CategoryClosedIcon } from 'assets/images/icons/category closed.svg'
import { ReactComponent as CategoryOpenedIcon } from 'assets/images/icons/category opend.svg'
import PagesList from './PagesList'
import { EmptyListCreateDraft } from './EmptyListCreateDraft'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'

export function Drafts(props) {
  const { searchText, preExpanded, my_drafts_list, shared_drafts_list } = props
  
    const { pathname } = useLocation();

  const getCurrentCategoryFromUrl = () => {
    const urlToArray = pathname?.split('/');
    return urlToArray[urlToArray.length - 1]
  }

  return (
    <>
      {(!searchText || (searchText && preExpanded.includes('my_drafts'))) && (
        <AccordionItemStyled uuid='my_drafts' className='accordionItem'>
          <AccordionItemHeading className='accordionItemHeading categorySection'>
            <AccordionItemButton className='accordionItemButton'>
              <AccordionItemState>
                {({ expanded }) => (
                  <div className='categoryName-wrapper'>
                    {expanded ? (
                      <div className='expandButton expanded'>
                        <ExpandedOn />
                      </div>
                    ) : (
                      <div className='expandButton'>
                        <ExpandedOff />
                      </div>
                    )}
                    <div className={`categoryName ml-1 mr-3 ${'my_drafts' === getCurrentCategoryFromUrl() ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>
                      <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>
                      <Link to={`/page/drafts/my_drafts`}>
                        <span className='ml-2'>My Drafts</span>
                      </Link>
                    </div>
                  </div>
                )}
              </AccordionItemState>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className='AccordionItemPanel pages'>
            {my_drafts_list.length > 0 && <PagesList pages={my_drafts_list} level={1} />}
            {!searchText && <EmptyListCreateDraft type='page' level={1} category={{ contents: my_drafts_list }} />}
          </AccordionItemPanel>
        </AccordionItemStyled>
      )}

      {/* Shared Drafts */}
      {(!searchText || (searchText && preExpanded.includes('shared_drafts'))) && (
        <AccordionItemStyled uuid='shared_drafts' className='accordionItem'>
          <AccordionItemHeading className='accordionItemHeading categorySection'>
            <AccordionItemButton className='accordionItemButton'>
              <AccordionItemState>
                {({ expanded }) => (
                  <div className='categoryName-wrapper'>
                    {expanded ? (
                      <div className='expandButton expanded'>
                        <ExpandedOn />
                      </div>
                    ) : (
                      <div className='expandButton'>
                        <ExpandedOff />
                      </div>
                    )}
                    <div className={`categoryName ml-1 mr-3 ${'shared_drafts' === getCurrentCategoryFromUrl() ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>
                      <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>
                      <Link to={`/page/drafts/shared_drafts`}>
                        <span className='ml-2'>Shared Drafts</span>
                      </Link>
                    </div>
                  </div>
                )}
              </AccordionItemState>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className='AccordionItemPanel pages'>
            {!searchText && shared_drafts_list.length === 0 && <EmptyListCreateDraft type='page' level={1} hideAddDraftLink={true} />}
            {shared_drafts_list.length > 0 && <PagesList pages={shared_drafts_list} level={1} />}
          </AccordionItemPanel>
        </AccordionItemStyled>
      )}
    </>
  )
}

const mapDispatchToProps = () => ({})
const mapStateToProps = (state) => ({
  selectedPageOrDraft: state.contents.selectedPageOrDraft
})
export default connect(mapStateToProps, mapDispatchToProps)(Drafts)
